/**
 * DASHBOARD-PARTICIPATION-MINI-SKELETON.WIDGET
 * Skeleton adapté à dashboard-participation-mini.widget.tsx (vue d'ensemble) : les trois statistiques
 * (taux, invités, terminés) sont en ligne, comme dans la card chargée (490 x 203), pour qu'elle garde sa taille.
 */
import Skeleton from "@/components/skeleton"

export default function DashboardParticipationMiniSkeletonWidget() {
  return (
    <div style={{ display: "flex", width: "100%", minHeight: 163, alignItems: "center", justifyContent: "space-around" }}>
      {[0, 1, 2].map((i) => (
        <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, width: 130 }}>
          <Skeleton width={90} height={12} />
          <Skeleton width={110} height={13} />
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10 }}>
            <Skeleton width={20} height={20} isCircle />
            <Skeleton width={38} height={24} />
          </div>
        </div>
      ))}
    </div>
  )
}
